import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Container, Paper, Stack, Typography } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";

const brand = "#800b33";
const brandDark = "#5f0826";

function PageNotFound({ isAuthenticated }) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        background: "radial-gradient(circle at top, rgba(128,11,51,0.18), transparent 45%), linear-gradient(135deg, #fdf2f8 0%, #fff7ed 100%)",
        px: 2,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            borderRadius: 6,
            overflow: "hidden",
            border: "1px solid rgba(128,11,51,0.12)",
            boxShadow: "0 28px 80px rgba(128,11,51,0.12)",
          }}
        >
          <Box
            sx={{
              px: { xs: 3, md: 6 },
              py: { xs: 5, md: 7 },
              background: "linear-gradient(135deg, rgba(128,11,51,0.96), rgba(95,8,38,0.96))",
              color: "#fff",
            }}
          >
            <Typography variant="overline" sx={{ letterSpacing: "0.18em", opacity: 0.9 }}>
              Savvy Community
            </Typography>
            <Typography variant="h1" sx={{ fontSize: { xs: "4.5rem", md: "6rem" }, fontWeight: 900, lineHeight: 1 }}>
              404
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
              This page does not exist
            </Typography>
            <Typography variant="body1" sx={{ maxWidth: 560, opacity: 0.9 }}>
              The link you followed is invalid, expired, or no longer available. Use one of the actions below to continue safely inside the platform.
            </Typography>
          </Box>

          <Box sx={{ px: { xs: 3, md: 6 }, py: { xs: 4, md: 5 } }}>
            <Stack spacing={2.5}>
              <Typography variant="body2" color="text.secondary">
                Recommended next steps
              </Typography>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                <Button
                  variant="contained"
                  size="large"
                  startIcon={isAuthenticated ? <DashboardRoundedIcon /> : <LoginRoundedIcon />}
                  onClick={() => navigate(isAuthenticated ? "/app" : "/login", { replace: true })}
                  sx={{
                    bgcolor: brand,
                    px: 3,
                    py: 1.4,
                    borderRadius: 999,
                    "&:hover": { bgcolor: brandDark },
                  }}
                >
                  {isAuthenticated ? "Go to dashboard" : "Go to login"}
                </Button>
                <Button
                  variant="outlined"
                  size="large"
                  startIcon={<ArrowBackRoundedIcon />}
                  onClick={() => navigate(-1)}
                  sx={{
                    px: 3,
                    py: 1.4,
                    borderRadius: 999,
                    color: brand,
                    borderColor: "rgba(128,11,51,0.35)",
                  }}
                >
                  Go back
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default PageNotFound;
